// extracted by mini-css-extract-plugin
export default {"addToCartControl":"I1-z","giftCard":"J1-z","btnContainer":"K1-z","cartButton":"L1-z","disabled":"M1-z"};